import { getSOCReports } from './API';

const GetSOCReportList = async (accessToken) => {
  try {
    const response = await getSOCReports(accessToken);
    return { success: true, data: response.data };
  } catch (error) {
    const errorMsg = !!error.response?.data ? error.response.data?.message : 'Error: API call to retrieve SOC reports failed.';
    return { success: false, data: errorMsg};
  }
};

export default GetSOCReportList;
